module.exports = __webpack_public_path__ + "images/180_4096.jpg";